export const APP_DESCRIPTION = 'Generate sacrifice addresses with inputs from multiple blockchains.'

export const NETWORK_POINTS_INFO =
  'Shows credit points earned from sacrifices on this network only. Flat-rate and volume bonus points are excluded — bonus points are linked to addresses which may operate across networks.'

export const UNIQUE_TOKENS_INFO =
  'Tokens not shown in this UI may still be considered, but price may include future sale slippage or other factors.'

export const INVALID_TOKENS_INFO =
  'These tokens are listed in the system but currently have no valid price source. Sacrifices sent with these tokens will not receive points.'

export const UNCONFIGURED_TOKENS_INFO =
  'These tokens appeared in sacrifice transactions but are not recognized by this project. They have no price source and will likely not receive points.'

export const PRICE_DISCLAIMER =
  'Prices may be manually changed, sacrifices and tokens may be added/removed or changed, any other factor may be intervened upon at any time for any reason.'

export const IMAGE_SERVER_URL = import.meta.env.VITE_IMAGE_SERVER_URL || 'https://gib.show'
